"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const moment_1 = tslib_1.__importDefault(require("moment"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_components_1 = require("@apollo/react-components");
const reusables_1 = require("../../../../comps/reusables");
const graphql_1 = require("../../../../graphql");
const react_2 = require("@osmosys/react");
const InviteButton = (props) => {
    return (react_1.default.createElement(react_components_1.Mutation, { mutation: graphql_1.inviteUser, variables: { id: props.userId }, refetchQueries: [{ query: graphql_1.user, variables: { id: props.userId } }] }, (mutationFunction, mutationResult) => {
        const isSuccess = !!mutationResult.data;
        let label;
        const userIsSetup = props.acceptedInvite || props.hasPassword;
        if (mutationResult.loading) {
            label = 'Sending invite';
        }
        else if (isSuccess) {
            label = 'Invitation sent';
        }
        else if (userIsSetup) {
            label = 'Invitation accepted';
        }
        else {
            label = (react_1.default.createElement(react_1.default.Fragment, null,
                props.invites.length === 0 ? 'Invite' : 'Invite again',
                props.invites.length !== 0 && (react_1.default.createElement("small", null, ` (${props.invites.length}
invite${props.invites.length === 1 ? ' has' : 's have'} already been sent)`))));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.OsmosysTooltip, { label: react_1.default.createElement(react_1.default.Fragment, null,
                    "Last invite sent",
                    ' ',
                    moment_1.default(props.invites
                        .map(invite => moment_1.default(invite.createdAt).valueOf())
                        .sort((a, b) => b - a)[0]).format('LLLL')) },
                react_1.default.createElement(reusables_1.AjaxButton, { id: "inviteButton", label: label, success: !!mutationResult.data, error: mutationResult.error, loading: mutationResult.loading, disabled: userIsSetup || !!mutationResult.data, icon: mutationResult.data ? pro_solid_svg_icons_1.faCheck : undefined, size: "sm", onClick: () => {
                        if (props.onInvite) {
                            props.onInvite();
                        }
                        mutationFunction();
                    } })),
            mutationResult.error && (react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "UserInvite", action: "create", apolloError: mutationResult.error }))));
    }));
};
exports.default = InviteButton;
//# sourceMappingURL=InviteButton.js.map